import { FC } from 'react';
import { ic_dropdown_down } from '.';

const DropDownIcon: FC<{ width?: number }> = ({ width = 16 }) => {
  return <img src={ic_dropdown_down} width={width} alt="" />;
};

export default DropDownIcon;
